import { useEffect, useState } from "react";
import { useLogout } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { HTTP_MAINTENANCE_STATUS } from "@/constants";
import { setupInterceptors } from "../services/api";
import { CustomError } from "components/ErrorBoundary";

// Module-level state for synchronous initialization
let logoutCallback: (() => void) | null = null;
let ltiSessionExpiredCallback: (() => void) | null = null;
let interceptorsConfigured = false;
let setErrorCallback: ((error: Error) => void) | null = null;

// Configure interceptors immediately at module load time
if (!interceptorsConfigured) {
  interceptorsConfigured = true;
  setupInterceptors({
    onMaintenanceError: (_error): void => {
      setErrorCallback?.(
        new CustomError(
          t("maintenance.message"),
          t("maintenance.title"),
          HTTP_MAINTENANCE_STATUS
        )
      );
    },
    onAuthenticationFailure: () => {
      logoutCallback?.();
    },
    onLtiSessionExpired: () => {
      ltiSessionExpiredCallback?.();
    },
  });
}

export const NetworkManager = () => {
  const [error, setError] = useState<Error | null>(null);
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();

  // Update the callbacks when component mounts
  useEffect(() => {
    setErrorCallback = setError;
    // authProvider.logout() now handles all cleanup via authService
    logoutCallback = () => {
      logout();
    };
    ltiSessionExpiredCallback = () => {
      navigate("/lti/session-expired", { replace: true });
    };
    return () => {
      setErrorCallback = null;
      logoutCallback = null;
      ltiSessionExpiredCallback = null;
    };
  }, [logout, navigate, setError]);

  if (error) {
    throw error; // This will trigger the nearest error boundary
  }
  return null;
};
